import {
  defaultTo,
  find,
  isEmpty,
  isNil,
  path,
  pipe,
  propEq,
  propOr,
} from 'ramda'

/**
 * Determines which table of rates to display based on what filter selection a
 * user has made. Doctors, facilities and pharmacies all have their own table
 * for displaying care rates.
 *
 * @param {obj} filters The filters for this care service/item
 * @param {str} categorySlug The category of this care service/item
 */
export const getCostListType = (filters = [], categorySlug = '') => {
  // Early return if we don't have the data we need
  if (isEmpty(filters) || isNil(filters)) {
    return ''
  }

  // Check if we have a receiveAt filter
  const receiveAtFilter = find(propEq('name', 'receiveAt'), filters)

  if (!receiveAtFilter) {
    // If no receiveAt filter, check if it's a prescription, if so we
    // can return the cost list type as PHARMACY
    if (categorySlug === 'prescriptions') {
      return 'PHARMACY'
    }
    return ''
  }

  const receiveAt = pipe(
    find(propEq('name', 'receiveAt')),
    defaultTo({}),
    propOr([], 'options'),
    find(propEq('selected', true)),
    path(['queryMap', 'location']),
  )(filters)

  switch (receiveAt) {
    case 'ambulatory-surgical-center':
    case 'outpatient-hospital-facility':
    case 'inpatient-hospital-facility':
      return 'FACILITY'

    case 'home-or-office':
    case 'home':
      return 'DOCTOR'

    default:
      if (categorySlug === 'prescriptions') {
        return 'PHARMACY'
      }
      break
  }
}
